import React from 'react';
import Button from '../../../components/ui/Button';

const ExportControls = ({ onPrint, onExport }) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-brand-md p-4 md:p-6">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4">
        <div>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
            ส่งออกข้อมูล
          </h3>
          <p className="text-sm text-muted-foreground">Export Data</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            iconName="Printer"
            iconPosition="left"
            onClick={onPrint}
            className="w-full sm:w-auto"
          >
            พิมพ์แผนภูมิ (Print)
          </Button>
          <Button
            variant="default"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
            className="w-full sm:w-auto"
          >
            ดาวน์โหลด PDF (Download)
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExportControls;